/**
 * AJAX ATC button.
 * 
 */

/**
 * 
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function initVariableAjaxAtc() {
	console.log('initVariableAjaxAtc()');

	$('.qty').on('input change', function() {
		console.log('QUANTITY CHANGE');
		$('.ajax_add_to_cart.pdp-product').attr('data-quantity', $(this).val());
	});

	$('form.cart').on( 'click', 'button.plus, button.minus', function() {
		console.log('QUANTITY CHANGE DELAY');
		setTimeout(function() {
			$('.ajax_add_to_cart.pdp-product').attr('data-quantity', $('.qty').val());
		}, 100);
	});

	$('.variable-item.button-variable-item').on('click', function() {
		console.log('VARIATION SELECT');
		setTimeout(function() {
			var varid = $( '.variation_id' ).attr('value');
			$('.ajax_add_to_cart.pdp-product').attr('data-product_id', varid).attr('value', varid);
		}, 100);
	})
}

exports.init = function () {
    // Run init methods...
    initVariableAjaxAtc();
};